import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Eye, Pencil, Trash2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/apiClient";
import { AdminHeader, AdminPage, StateBadge } from "@/components/admin/AdminUI";
import { Button } from "@/components/ui/button";

export default function PressList() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const load = () => api.get("/press?include_unpublished=true&limit=200").then(({ data }) => setItems(data.items)).catch(() => {}).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);
  const del = async (p) => { if (!window.confirm("Delete this release?")) return; await api.delete(`/press/${p.id}`); toast.success("Deleted"); load(); };

  return (
    <>
      <AdminHeader title="Press Releases" subtitle={`${items.length} releases`} actions={
        <Button asChild className="bg-npst-navy hover:bg-npst-navyDeep text-white"><Link to="/admin/press/new" data-testid="add-press-btn"><Plus size={16} className="mr-1.5" /> New Press Release</Link></Button>
      } />
      <AdminPage>
        <div className="bg-white border border-slate-200 rounded-lg overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 border-b border-slate-200"><tr className="text-left text-[11px] uppercase tracking-wider text-slate-500">
              <th className="px-4 py-3">Headline</th><th className="px-4 py-3">Category</th><th className="px-4 py-3">Date</th><th className="px-4 py-3">State</th><th className="px-4 py-3 text-right">Actions</th>
            </tr></thead>
            <tbody>
              {loading ? <tr><td colSpan={5} className="px-4 py-10 text-center text-slate-400 animate-pulse">Loading…</td></tr>
                : items.length === 0 ? <tr><td colSpan={5} className="px-4 py-10 text-center text-slate-400">No press releases yet.</td></tr>
                : items.map((p) => (
                  <tr key={p.id} className="border-b border-slate-100 hover:bg-slate-50">
                    <td className="px-4 py-3 font-medium text-npst-ink max-w-md truncate">{p.headline}</td>
                    <td className="px-4 py-3 text-xs">{p.category}</td>
                    <td className="px-4 py-3 text-xs font-mono text-slate-500">{p.publish_date}</td>
                    <td className="px-4 py-3"><StateBadge state={p.state} /></td>
                    <td className="px-4 py-3"><div className="flex items-center justify-end gap-3 text-slate-400">
                      {p.state === "published" && <a href={`/media/${p.slug}`} target="_blank" rel="noopener noreferrer" className="hover:text-npst-navy"><Eye size={16} /></a>}
                      <Link to={`/admin/press/${p.id}`} className="hover:text-npst-navy" data-testid={`edit-press-${p.id}`}><Pencil size={16} /></Link>
                      <button onClick={() => del(p)} className="hover:text-red-600"><Trash2 size={16} /></button>
                    </div></td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </AdminPage>
    </>
  );
}
